import React, { useState } from 'react';
import styles from './ChatHeader.module.scss';
import searchSvg from '../../../../../assets/icons/vector/search.svg';
import SearchInput from 'component/atom/forms/input/searchInput/SearchInput';
import { useResponsive } from 'assets/styles/breakpoints/breakpoint';
import { SideBarState } from 'app-context/mobile-sidebar-state/MobileSibebar';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import Button from 'component/atom/forms/button/Button';

const ChatHeader = ({ isExpanded, onSearch, onNewChatClick }) => {
  return (
    <div
      className={`${styles['chat-header']} ${
        isExpanded ? styles['expand'] : styles['collapse']
      }`}
    >
      <div className={styles['navigation-container']}>
        <div
          className={`${styles['navigation']} ${
            isExpanded ? styles['expand'] : styles['collapse']
          }`}
        >
          <div className={styles['left-container']}>
            <h2>Chat History</h2>
          </div>
          <div className={styles['right-container']}>
            <Button
              label="New chat"
              className={styles.button}
              type="plus"
              onClick={onNewChatClick}
            />
          </div>
        </div>
        <div className={styles['is-searching-open']}>
          <SearchInput
            classname={styles.input}
            onChange={(name, value) => onSearch(value)}
            placeholder="Search Chat"
          />
        </div>
      </div>
    </div>
  );
};

export default ChatHeader;
